import { Item } from "@dto/records";
import { TW_TextCell, TW_TextCell_editing } from "@utils/twClasses";
import { RefObject, useEffect, useState } from "react";
import { useModelStore, useUserStore } from "src/store";
import { AbstractCell } from "./AbstractCell";
import { CellProps } from "./GridCell";
import { EditRightAccess, hasGlobalRightAccess, ObjectRightType, ViewRightType } from "@dto/Users";
import { displayText } from "@utils/types";

export function UrlCell({ pathKey, field, item, position, updateValue, isEditing, inputRef, blurTriggered }: CellProps) {

    const user = useUserStore(state => state.user);
    const [text, setText] = useState(item ? item.value || "" : "");
    const wsColor = useModelStore(state => state.wsColor);
    const [lastBlurTriggered, setLastBlurTriggered] = useState<number | null>(null);
    const userRole = useModelStore(state => state.userRole);
    const selectedObjectInfos = useModelStore(state => state.selectedObjectInfos);
    const selectedView = useModelStore(state => state.selectedView);
    const hasEditAccessOnObject = hasGlobalRightAccess(user, userRole, ObjectRightType, EditRightAccess, selectedObjectInfos?.object?._key);
    const hasEditAccessOnView = hasGlobalRightAccess(user, userRole, ViewRightType, EditRightAccess, selectedView?._key);
    const hasEditAccess = hasEditAccessOnObject && hasEditAccessOnView;
    const readOnly = item.readOnly || !hasEditAccess ;
    const format = selectedView?.formats?.get(pathKey ?? "") ?? field?.format;

    // console.log("Rendering UrlCell", posToString(position) + " - " + text, item?.value);

    useEffect(() => {
        if (item?.value !== text) {
            setText(item ? item.value || "" : "");
        }
    }, [item]);
    
    useEffect(() => {
        const newValue = textToValue(text);
        if (isEditing && lastBlurTriggered && blurTriggered && lastBlurTriggered !== blurTriggered && item?.value !== newValue) {
            updateValue(item, newValue);
        }
        setLastBlurTriggered(blurTriggered);
    }, [blurTriggered]);

    const updateLocalValue = (item: Item, value: any) => {
        setText(value || "");
        updateValue(item, value);
    }

    const textToValue = (text: string | null): any => {
        return displayText(text, format);
    }

    function isTextValid(_value: string | null) {
        return true;
    }

    const renderReadOnlyContent = () => {
        let value = text;
        let url = value;
        const splitValue = value.split("@");
        if (splitValue.length === 2) {
            value = splitValue[0];
            url = splitValue[1];
        } else if (splitValue.length > 2) {
            const lastIndex = value.lastIndexOf("@");
            url = value.substring(lastIndex + 1);
            value = value.substring(0, lastIndex);
        }
        const displayed = displayText(value, format);
        return (
            <div className={TW_TextCell + (field.name ? " " : " text-center ") + (readOnly ? " cursor-not-allowed" : "")}>
                <a href={url} target="_blank" className="text-blue-500" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>{displayed}</a>
            </div>
        )
    }

    const renderEditingContent = (
        onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
        onEnterKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void,
        inputRef: RefObject<HTMLInputElement>
    ) => {
        return (
            <input
                className={TW_TextCell_editing}
                type="text"
                value={text ?? ""}
                onChange={onTextChange}
                onKeyDown={onEnterKeyPress}
                autoFocus={true}
                style={{ borderColor: wsColor }} 
                ref={inputRef}
            />
        )
    }

    return <AbstractCell
        item={item}
        position={position}
        updateValue={updateLocalValue}
        renderReadOnlyContent={renderReadOnlyContent}
        renderEditingContent={renderEditingContent}
        textToValue={textToValue}
        isTextValid={isTextValid}
        text={text}
        setText={setText}
        isEditing={isEditing}
        inputRef={inputRef}
        readOnly={readOnly}
    />
}
